export const NO_AUTHORIZATION_HEADER = null as any
